export default function DriverOrdersToolbar({filter,setFilter,text,canRequestLeave=true,canViewReports=true,reportTitle,onLeave,onAdd,onRefresh,onReport}) { return <>
            <div className="driver-filter-tabs">
              {[
                { key: 'upcoming', label: text.upcoming },
                { key: 'completed', label: text.completed },
                { key: 'all', label: text.all },
              ].map(tab => (
                <button
                  key={tab.key}
                  onClick={() => setFilter(tab.key)}
                  className={`driver-filter-tab ${
                    filter === tab.key
                      ? 'driver-filter-tab-active'
                      : ''
                  }`}
                  data-testid={`filter-${tab.key}`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="driver-list-toolbar-actions">
              {canViewReports && <button type="button" className="driver-list-toolbar-pill" onClick={() => onReport()}>{reportTitle}</button>}
              {canRequestLeave && (
                <button
                  type="button"
                  onClick={() => onLeave()}
                  className="driver-list-toolbar-pill"
                  data-testid="driver-time-off-button"
                  title={text.timeOff}
                  aria-label={text.timeOff}
                >
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
                    <path d="M7 3v3M17 3v3M4.5 9h15M6 5h12a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                  </svg>
                  <span>{text.timeOff}</span>
                </button>
              )}

              <button
                onClick={() => { onAdd(); }}
                className="driver-list-toolbar-pill"
                data-testid="add-extra-schedule-button"
                title={text.add}
                aria-label={text.add}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                <span>{text.add}</span>
              </button>

              <button
                onClick={() => { onRefresh(); }}
                className="driver-list-toolbar-pill"
                data-testid="refresh-orders-button"
                title={text.refresh}
                aria-label={text.refresh}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                <span>{text.refresh}</span>
              </button>
            </div>
</>; }
